import { createContext, useContext } from 'react';

/**
 * @internal
 */
export const GaugeChartTooltipNameContext = createContext<string | undefined>(
  undefined,
);

/**
 * @internal
 */
export const useGaugeChartTooltipName = () =>
  useContext(GaugeChartTooltipNameContext);
